import {Formik} from 'formik';
import {Button, Group} from '@mantine/core';
import {MdCancel, MdCheck, MdClear} from 'react-icons/md';
import {FilterFormComponent} from './FilterFormComponent';
import {FilterFormSchema} from './FilterFormSchema';
import {toFormikValidationSchema} from 'zod-formik-adapter';
import {useMeteringRecordsFilter} from '../../hooks/useMeteringRecords';

interface FilterFormProps {
    onApply: () => void;
    onCancel: () => void;
}

interface FilterFormValues {
    state?: string;
    customerId?: string;
}

export const FilterForm = ({onApply, onCancel}: FilterFormProps) => {
    const {filters, handleSetFilters, handleClearFilters} = useMeteringRecordsFilter();

    const initialValues: FilterFormValues = {
        state: filters.state || '',
        customerId: filters.customerId || '',
    };

    const onSubmit = (values: FilterFormValues) => {
        const clean = Object.entries(values).reduce((acc, [key, value]) => {
            if (value && value !== '') {
                acc[key] = value;
            }
            return acc;
        }, {} as Record<string, string>);

        handleSetFilters(clean);
        onApply();
    };

    return (
        <Formik<FilterFormValues>
            initialValues={initialValues}
            validationSchema={toFormikValidationSchema(FilterFormSchema)}
            onSubmit={onSubmit}
        >
            {({handleSubmit, resetForm}) => (
                <>
                    <FilterFormComponent/>

                    <Group justify="space-between" mt="xl">
                        <Button
                            variant="outline"
                            leftSection={<MdCancel/>}
                            onClick={onCancel}
                        >
                            Cancel
                        </Button>
                        <Group gap="xs">
                            <Button
                                variant="outline"
                                leftSection={<MdClear/>}
                                onClick={() => {
                                    resetForm();
                                    handleClearFilters();
                                }}
                            >
                                Clear
                            </Button>
                            <Button
                                leftSection={<MdCheck/>}
                                onClick={() => handleSubmit()}
                            >
                                Apply
                            </Button>
                        </Group>
                    </Group>
                </>
            )}
        </Formik>
    );
};
